// ----------------------------------------------------------------------

const MuiAppBar = {
  defaultProps: { color: 'transparent' },

  styleOverrides: { root: { boxShadow: 'none' } },
};

// ----------------------------------------------------------------------

export const appBar = { MuiAppBar };
